
import React from 'react';
import "./MasterFiles.scss"
import { Grid, ThemeProvider } from "@material-ui/core";
import { lightTheme } from '../../../Themes/LightTheme';
import RoleMaster from './MasterTabs/RoleMaster';
import MaterialMaster from './MasterTabs/MaterialMaster';
import SupplierMaster from './MasterTabs/SupplierMaster';

export default function MasterFiles() {
    return (
        <ThemeProvider theme={lightTheme}>
            <>
                <div className="master-paperSty">
                    <div className="master-data">
                    {/*    <Grid container spacing={2} className="master-div">*/}
                    {/*        <Grid item xs={12} md={12} className="d-flex fd-col pd-1">*/}
                    {/*            <h3 className="d-flex jc-center">Supplier Master</h3>*/}
                    {/*            <SupplierMaster />*/}
                    {/*        </Grid>*/}
                    {/*        <Grid item xs={12} md={12} className="d-flex fd-col pd-1">*/}
                    {/*            <h3 className="d-flex jc-center">Role Master</h3>*/}
                    {/*            <RoleMaster />*/}
                    {/*        </Grid>*/}
                    {/*        <Grid item xs={12} md={12} className="d-flex fd-col pd-1">*/}
                    {/*            <h3 className="d-flex jc-center">Part Master</h3>*/}
                    {/*            <MaterialMaster />*/}
                    {/*        </Grid>*/}
                    {/*    </Grid>*/}
                        

                        <Grid style={{ display:'flex' ,flexDirection:'column',marginTop:'10px'} }>
                            <Grid item xs={12} className="left-div">
                                <h3 className="heading">Supplier Master</h3>
                            </Grid>
                            <Grid><SupplierMaster /></Grid>

                        </Grid>

                        <Grid style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                            <Grid item xs={12} className="left-div">
                                <h3 className="heading">Role Master</h3>
                            </Grid>
                            <Grid><RoleMaster /></Grid>

                        </Grid>

                        <Grid style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
                            <Grid item xs={12} className="left-div">
                                <h3 className="heading">Part Master</h3>
                            </Grid>
                            <Grid><MaterialMaster /></Grid>

                        </Grid>

                        
                    </div>
                </div>
            </>
        </ThemeProvider>
    );
}